module.exports = __webpack_public_path__ + "img/invoice-logo.cec56bef.png";